module.exports = __webpack_public_path__ + "img/icon-pic.e8a659ed.svg";